/* global helpers */

jQuery(window).on('load', () => {
    //finding all instagram posts when they have been fully loaded (otherwise they will not appear), and set their minimum width
    let $instagramEmbeds = jQuery('iframe.instagram-media');
    $instagramEmbeds.each(function(idx, element) {
        //min-width is needed for very small sizes, otherwise the height will cause the page flow to break
        jQuery(element).css("min-width", "100px");
    });
});

jQuery(document).ready(function($) {
    // Find all iframes on current page
    var $embeds = $('iframe:not(.instagram-media), video');

    // If there are iframes, continue
    if ($embeds.length) {
        // Find and save the aspect ratio for all iframes
        $embeds.each(function () {
            $(this)
                .data('ratio', $(this).height()/$(this).width())
                .removeAttr('width')
                .removeAttr('height');
        });

        // Resize the iframes when the window is resized (also call initially)
        $(window).resize(helpers.debounce(function embedDebounce() {
            $embeds.each(function () {
                // Get the parent container's width and aspect ratio
                var width = $(this).parent().width();
                var ratio = $(this).data('ratio');

                // Set width and height based on aspect ratio
                $(this)
                    .width(width)
                    .height(width * ratio);
            });
        }, 100)).resize();
    }
});

